if (!customElements.get("quick-add-modal")) {
    customElements.define(
        "quick-add-modal",
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            }

            hide(preventFocus = false) {
                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
                
                // Clean up event listeners before clearing content
                $(document).off("click.quickAddModal");
                $(document).off("change.quickAddModal");
                
                this.modalContent.innerHTML = "";

                $(".js-media-list").each(function () {
                    if (this.swiper) this.swiper.destroy();
                });
                $(".js-media-sublist").each(function () {
                    if (this.swiper) this.swiper.destroy();
                });

                subSliderInit(true);
                sliderInit(true);
                updatethumbnail();

                if (preventFocus) this.openedBy = null;
                super.hide();
            }

            show(opener) {
                opener.setAttribute("aria-disabled", true);
                opener.classList.add("loading");

                this.addEventListener(
                    "transitionend",
                    () => {
                        const containerToTrapFocusOn = document.getElementById(
                            opener.getAttribute("data-modal-open")
                        );
                        const focusElement = this.querySelector(".modal-close-button");
                        trapFocus(containerToTrapFocusOn, focusElement);
                    },
                    { once: true }
                );

                if (opener.querySelector(".loading-overlay__spinner")) {
                    opener
                        .querySelector(".loading-overlay__spinner")
                        .classList.remove("hidden");
                }

                fetch(opener.getAttribute("data-product-url"))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(
                            responseText,
                            "text/html"
                        );
                        this.productElement = responseHTML.querySelector(
                            'section[id^="MainProduct-"]'
                        );
                        this.preventDuplicatedIDs();
                        this.removeDOMElements();
                        this.setInnerHTML(
                            this.modalContent,
                            this.productElement.innerHTML,
                            opener
                        );

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        if (window.ProductModel) window.ProductModel.loadShopifyXR();

                        this.removeGalleryListSemantic();
                        this.updateImageSizes();
                        this.preventVariantURLSwitching();
                        super.show(opener);

                        // Initialize dropdowns for quick-add modal with scoped selectors
                        const modal = this.modalContent;
                        $(modal).find(".product-form__input--dropdown").each(function () {
                            const dropdown = $(this);
                            const elListItem = dropdown.find(".dropdown-select ul li");
                            const elItem = dropdown.find(".dropdown-select ul");
                            const selectedText = dropdown.find(".dropdown-select .select-label");

                            selectedText.off("click").on("click", function (e) {
                                e.stopPropagation();
                                
                                // Close all other dropdowns in the modal only
                                $(modal).find(".product-form__input--dropdown .dropdown-select ul").not(elItem).removeClass("active");
                                
                                // Toggle this dropdown
                                elItem.toggleClass("active");
                                
                                if (elItem.hasClass("active")) {
                                    $(document).off("click.quickAddModal").on("click.quickAddModal", function (clickEvent) {
                                        // Only close if clicking outside the modal
                                        if (!$(clickEvent.target).closest(modal).length || !$(clickEvent.target).closest('.dropdown-select').length) {
                                            elItem.removeClass("active");
                                        }
                                    });
                                }
                            });

                            elListItem.off("click").on("click", function () {
                                selectedText.text($(this).text()).attr("title", $(this).text());
                                elItem.removeClass("active");
                                document.activeElement.blur();
                            });
                        });
                    })
                    .finally(() => {
                        opener.removeAttribute("aria-disabled");
                        opener.classList.remove("loading");

                        if (opener.querySelector(".loading-overlay__spinner")) {
                            opener
                                .querySelector(".loading-overlay__spinner")
                                .classList.add("hidden");
                        }

                        document.querySelector("cart-drawer").classList.remove("active");

                        subSliderInit();
                        sliderInit();
                        updatethumbnail();
                        
                        // Hide unavailable variant options and auto-select first available
                        const modal = this.modalContent;
                        const hideUnavailableOptionsQuickAdd = () => {
                            $(modal).find(".product-form__input--dropdown").each(function () {
                                const dropdown = $(this);
                                const listItems = dropdown.find(".dropdown-select ul li");
                                let hasVisibleChecked = false;
                                let firstAvailableInput = null;
                                
                                listItems.each(function() {
                                    const input = $(this).find("input[type='radio']");
                                    
                                    if (input.hasClass("disabled")) {
                                        $(this).hide();
                                    } else {
                                        $(this).show();
                                        
                                        if (!firstAvailableInput) {
                                            firstAvailableInput = input;
                                        }
                                        
                                        if (input.is(":checked")) {
                                            hasVisibleChecked = true;
                                        }
                                    }
                                });
                                
                                if (!hasVisibleChecked && firstAvailableInput) {
                                    firstAvailableInput.prop("checked", true);
                                    
                                    // Update the dropdown label
                                    const selectedText = dropdown.find(".dropdown-select .select-label");
                                    selectedText.text(firstAvailableInput.val()).attr("title", firstAvailableInput.val());
                                    
                                    // Trigger the variant change event to update image/price/button
                                    const changeEvent = new Event('change', { bubbles: true });
                                    firstAvailableInput.get(0).dispatchEvent(changeEvent);
                                    
                                    // Manually trigger variant update without opening dropdown
                                    const variantRadios = firstAvailableInput.closest('variant-radios');
                                    if (variantRadios && variantRadios.length) {
                                        variantRadios[0].onVariantChange();
                                    }
                                }
                            });
                        };

                        hideUnavailableOptionsQuickAdd();

                        $(document).off("change.quickAddModal").on("change.quickAddModal", `#${modal.id} .product-form__input--dropdown input[type='radio']`, function() {
                            setTimeout(hideUnavailableOptionsQuickAdd, 100);
                        });
                    });
            }

            setInnerHTML(element, html, opener) {
                element.innerHTML = html;

                // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
                element.querySelectorAll("script").forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement("script");
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(attribute.name, attribute.value);
                    });
                    newScriptTag.appendChild(
                        document.createTextNode(oldScriptTag.innerHTML)
                    );
                    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });
            }

            removeDOMElements() {
                const pickupAvailability = this.productElement.querySelector(
                    "pickup-availability"
                );
                if (pickupAvailability) pickupAvailability.remove();

                const productModal = this.productElement.querySelector("product-modal");
                if (productModal) productModal.remove();

                const gift = this.productElement.querySelector(".customer");
                if (gift) gift.remove();
            }

            preventDuplicatedIDs() {
                const sectionId = this.productElement.dataset.section;
                this.productElement.innerHTML =
                    this.productElement.innerHTML.replaceAll(
                        sectionId,
                        `quickadd-${sectionId}`
                    );
                this.productElement
                    .querySelectorAll("variant-selects, variant-radios")
                    .forEach((variantSelect) => {
                        variantSelect.dataset.originalSection = sectionId;
                    });
            }

            preventVariantURLSwitching() {
                if (this.modalContent.querySelector("variant-radios,variant-selects")) {
                    this.modalContent
                        .querySelector("variant-radios,variant-selects")
                        .setAttribute("data-update-url", "false");
                }
            }

            removeGalleryListSemantic() {
                const galleryList = this.modalContent.querySelector(
                    '[id^="Slider-Gallery"]'
                );
                if (!galleryList) return;

                galleryList.setAttribute("role", "presentation");
                galleryList
                    .querySelectorAll('[id^="Slide-"]')
                    .forEach((li) => li.setAttribute("role", "presentation"));
            }

            updateImageSizes() {
                const product = this.modalContent.querySelector(".product");
                const desktopColumns = product.classList.contains("product--columns");
                if (!desktopColumns) return;

                const mediaImages = product.querySelectorAll(".product__media img");
                if (!mediaImages.length) return;

                let mediaImageSizes =
                    "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

                if (product.classList.contains("product--medium")) {
                    mediaImageSizes = mediaImageSizes.replace("715px", "605px");
                } else if (product.classList.contains("product--small")) {
                    mediaImageSizes = mediaImageSizes.replace("715px", "495px");
                }

                mediaImages.forEach((img) =>
                    img.setAttribute("sizes", mediaImageSizes)
                );
            }
        }
    );
}
